import * as actions from './master/actions'
import * as mutations from './master/mutations'
import * as getters from './master/getters'

import  { currencyProps } from './master/properties'

const state = {
    accessToken: null,
    encrypted_key: '',
    trial_account: false,
    days_left: 0,
    sms_credit: 0,
    accessibleModules: [],
    userInformation: null,
    country_list: [],
    province_list: [],
    city_list: [],
    e_store_menu_list: [],
    communication_variables: [],
    master_module_list: [],
    fabric_width_list: [],
    store_list: [],
    salutation_list: [],
    uom_list: [],
    fabric_gsm_list: [],
    user_group_alert: null,
    loadingState: true,
    machineId: null,
    breadcrumbs: [{icon: 'el-icon-s-home', target: '/'}],
    login: {
        user_name: '',
        password: ''
    },
    access_rights: {
        can_view: false,
        can_add: false,
        can_edit: false,
        can_delete: false,
        allow_limited_list_view: false
    },
    currency_format: JSON.parse(JSON.stringify(currencyProps)),
    default_page_limit: 10,
    max_discount_allowed: 0,
    enable_e_payment: false,
    dashboard: {
        date_range: [
            new Date(new Date().getFullYear(), new Date().getMonth() - 1, new Date().getDate()), 
            new Date()
        ],
        selected_store_id: 0,
        response: null
    },
    search_query_list: [],
    task_calendar_events: [],
    task_calendar_event_list: [],
    search_type: -1,
    search_term: '',
    whatsapp_license_list: [],
    payment_list: [],
    coupon_list: [],
    subscription_list: []
}

export default {
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/master.js